import { Layout } from "../components/Layout";
import { useHead } from "../lib/useHead";
import { AlertTriangle } from "lucide-react";

const ToComplete = ({ children }) => (
  <span className="rounded border border-dashed border-[hsl(var(--warn))]/60 bg-[hsl(var(--warn))]/5 px-1.5 py-0.5 text-[hsl(var(--warn))]">
    {children}
  </span>
);

export default function Confidentialite() {
  useHead({ title: "Politique de confidentialité — InfoSociété", description: "Politique de confidentialité du service privé InfoSociété.", robots: "noindex,follow" });
  return (
    <Layout>
      <div className="mx-auto max-w-3xl px-5 py-10">
        <h1 className="font-display text-3xl font-semibold tracking-tight text-[hsl(var(--fg-primary))]">Politique de confidentialité</h1>

        <div className="mt-4 flex items-start gap-2 rounded-lg border border-[hsl(var(--warn))]/40 bg-[hsl(var(--warn))]/5 p-4 text-sm text-[hsl(var(--fg-secondary))]">
          <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-[hsl(var(--warn))]" />
          <p>Les éléments en surbrillance sont <strong>à compléter</strong> par l'éditeur (coordonnées, responsable des traitements, durées exactes).</p>
        </div>

        <div className="mt-8 space-y-8 text-sm leading-relaxed text-[hsl(var(--fg-secondary))]">
          <section>
            <h2 className="font-display text-lg font-semibold text-[hsl(var(--fg-primary))]">Responsable du traitement</h2>
            <p className="mt-2">Le responsable du traitement est <ToComplete>[Raison sociale de l'éditeur]</ToComplete>, joignable à <ToComplete>[adresse e-mail]</ToComplete>.</p>
          </section>

          <section>
            <h2 className="font-display text-lg font-semibold text-[hsl(var(--fg-primary))]">Données relatives aux entreprises</h2>
            <p className="mt-2">
              Les informations affichées sur les entreprises sont des données publiques
              issues de sources officielles (INSEE / RNE). Elles ne constituent pas des
              données personnelles collectées par InfoSociété. Les dirigeants concernés peuvent
              exercer leurs droits directement auprès des organismes officiels producteurs de
              ces données.
            </p>
          </section>

          <section>
            <h2 className="font-display text-lg font-semibold text-[hsl(var(--fg-primary))]">Données de navigation et mesure d'audience</h2>
            <p className="mt-2">
              InfoSociété peut mesurer, de manière agrégée et anonyme, l'utilisation du service
              (recherches effectuées, clics vers le partenaire printer.fr) afin d'améliorer le
              service. Ces mesures ne permettent pas d'identifier une personne. Le dépôt de
              traceurs non essentiels est soumis à votre consentement conformément à la
              réglementation applicable.
            </p>
          </section>

          <section>
            <h2 className="font-display text-lg font-semibold text-[hsl(var(--fg-primary))]">Liens vers printer.fr</h2>
            <p className="mt-2">
              En cliquant sur « Créer mon tampon », vous êtes redirigé vers le site printer.fr,
              édité par une entité distincte et disposant de sa propre politique de
              confidentialité. Les coordonnées publiques de l'entreprise consultée peuvent être
              transmises via l'URL afin de faciliter la création du tampon ; vous pouvez les
              vérifier et les modifier sur printer.fr avant toute commande.
            </p>
          </section>

          <section>
            <h2 className="font-display text-lg font-semibold text-[hsl(var(--fg-primary))]">Conservation et droits</h2>
            <p className="mt-2">
              Les mesures d'audience anonymes sont conservées pendant <ToComplete>[durée à préciser]</ToComplete>.
              Pour toute question relative à vos données, contactez <ToComplete>[adresse e-mail]</ToComplete>.
              Vous disposez, le cas échéant, d'un droit d'accès, de rectification et d'opposition.
            </p>
          </section>
        </div>
      </div>
    </Layout>
  );
}
